import {generalRequest} from "../services";

export async function getGamificationGuide(args) {
    return generalRequest('student/gamification/guide', args)
}